<template lang="pug">
.d-contents
  slot
  app-checkbox(
    v-model="hideNextTime"
    hide-details
  ).mt-6
    template(#label)
      .text-body-1 Больше не показывать
  portal(
    :to="`${constants.DIALOG_PORTAL_KEY}.actions`"
  )
    .d-flex.full-width
      app-button(
        rounded
        large
        @click="onClose"
      ) Закрыть
</template>

<script>
import { DIALOG_PORTAL_KEY } from '../constants';

export default {
  name: 'WithActions',
  components: {},
  props: {},
  data() {
    return {
      hideNextTime: false,
    };
  },
  computed: {
    constants() {
      return {
        DIALOG_PORTAL_KEY,
      };
    },
  },
  watch: {},
  created() {},
  methods: {
    onClose() {
      if (this.hideNextTime) {
        this.$emit('hide-next-time', this.$user.data.id);
      }

      this.$emit('close');
    },
  },
};
</script>
